import { render, staticRenderFns } from "./AiSocial.vue?vue&type=template&id=a2408096&scoped=true"
import script from "./AiSocial.vue?vue&type=script&lang=js"
export * from "./AiSocial.vue?vue&type=script&lang=js"
import style1 from "./AiSocial.vue?vue&type=style&index=1&id=a2408096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2408096",
  null
  
)

export default component.exports